import { Component, EventEmitter, Output, OnInit, OnDestroy, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-session-popup',
  templateUrl: './session-popup.component.html',
  styleUrls: ['./session-popup.component.scss']
})
export class SessionPopupComponent implements OnInit, OnDestroy {
  @Output() extendSession = new EventEmitter<void>();
  @Output() dismissPopup = new EventEmitter<void>();
  @Output() countdownFinished = new EventEmitter<void>();
  @Input() remainingTimeInSeconds: number;

  countdown: number;
  private intervalId: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.countdown = this.remainingTimeInSeconds ?? 0;
    this.startCountdown();
    this.addVisibilityChangeListener();
  }

  ngOnDestroy() {
    this.clearCountdown();
    this.removeVisibilityChangeListener();
  }

  startCountdown() {
    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.cdr.detectChanges(); // Manually trigger change detection
      } else {
        this.clearCountdown();
        this.countdownFinished.emit();
      }
    }, 1000);
  }

  clearCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  onExtendSession() {
    this.extendSession.emit();
    this.clearCountdown();
  }

  onDismissPopup() {
    this.dismissPopup.emit();
    this.clearCountdown();
  }

  addVisibilityChangeListener() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }
  removeVisibilityChangeListener() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      if (this.countdown <= 0) {
        this.countdownFinished.emit();
      }
    }
  };

  get formattedCountdown() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;

    if (minutes > 0) {
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds} minute${minutes === 1 ? '' : 's'}`;
    } else {
      return `${seconds} second${seconds === 1 ? '' : 's'}`;
    }
  }
}
